<app-base-dashboard pageTitle="Custom Dashboard" icon="pi pi-cog">
    <div class="custom-contain-full">
        <!-- <div class="background"></div> -->
        <p-card class="page-card">
            <div class="divTitle-page-card">
                <h2>¡Bienvenido Usuario!</h2>
            </div>
            <div class="divContain-page-card">
                <p> Esta es la nueva plataforma de imadata, hecha para ofrecerte una mejor experiencia y puedas sacar mayor provecho a tu información.</p>
            </div>
        </p-card>
    </div>
    <div class="custom-contain">
        <p-card class="page-card2" >
            <p-chart width="400"
                height="0.9" type="bar" [data]="basicData" [options]="basicOptions"></p-chart>
        </p-card>
        <p-card class="page-card2">
            <p-chart width="400"
                height="0.9" type="line" [data]="data" [options]="options"></p-chart>
        </p-card>
        
        

        <p-card class="page-card2">
            <div class="card">
                <p-table
                [value]="customers"
                [paginator]="true"
                [rows]="5"
                [showCurrentPageReport]="true"
                [tableStyle]="{ 'min-width': '50rem' }"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10, 25, 50]"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:25%">Country</th>
                        <th style="width:25%">Company</th>
                        <th style="width:25%">Representative</th>
                        <th style="width:25%">Representative</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-customer>
                    <tr>
                        <td>{{ customer.name }}</td>
                        <td>{{ customer.name }}</td>
                        <td>{{ customer.name }}</td>
                        <td>{{ customer.name }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft">
                    <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                </ng-template>
                <ng-template pTemplate="paginatorright">
                    <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                </ng-template>
            </p-table>
            </div>
        </p-card>
        
        <p-card class="page-card2">
            <div class="card">
                <p-chart width="400"
                height="0.9" type="line" [data]="data" [options]="options"></p-chart>
            </div>
        </p-card>
        
    </div>
</app-base-dashboard>